import { render, staticRenderFns } from "./CartsMenuItem.vue?vue&type=template&id=d4360726&scoped=true&"
import script from "./CartsMenuItem.vue?vue&type=script&lang=ts&"
export * from "./CartsMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./CartsMenuItem.vue?vue&type=style&index=0&id=d4360726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4360726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/roy/Desktop/priv/vue/servant/servant/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileActionText } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VChip,VListTile,VListTileAction,VListTileActionText,VListTileContent,VListTileTitle})
